import { r as removeJXGEventHandlers, L as LINE_FAMILY_EVENTS, j as jxg } from "./JSXGraphRenderer-BcR36ozd.js";
import { e as exceededDragThreshold, p as pointerEventToUserCoords } from "./dragThreshold-DuSSFrIU.js";
function attachAnchoredGraphDragHandlers(params) {
  const {
    board,
    newJXG,
    newAnchorPoint,
    pointerState,
    pointAtDown,
    calculatedX,
    calculatedY,
    fixed,
    fixLocation,
    lastPositionFromCore,
    componentIdx,
    actions,
    callAction,
    actionNames
  } = params;
  newJXG.isDraggable = !fixLocation.current;
  newJXG.on("down", function(e) {
    document.activeElement?.blur();
    pointerState.pointerAtDown.current = [e.x, e.y];
    pointAtDown.current = [...newAnchorPoint.coords.scrCoords];
    pointerState.dragged.current = false;
    pointerState.pointerIsDown.current = true;
    pointerState.pointerMovedSinceDown.current = false;
    if (!fixed.current) {
      callAction({
        action: actions[actionNames.focused],
        args: { componentIdx }
      });
    }
  });
  newJXG.on("hit", function() {
    pointAtDown.current = [...newAnchorPoint.coords.scrCoords];
    pointerState.dragged.current = false;
    callAction({
      action: actions[actionNames.focused],
      args: { componentIdx }
    });
  });
  newJXG.on("up", function() {
    if (pointerState.dragged.current) {
      callAction({
        action: actions[actionNames.move],
        args: {
          x: calculatedX.current,
          y: calculatedY.current
        }
      });
      pointerState.dragged.current = false;
    } else if (!pointerState.pointerMovedSinceDown.current && !fixed.current) {
      callAction({
        action: actions[actionNames.clicked],
        args: { componentIdx }
      });
    }
    pointerState.pointerIsDown.current = false;
  });
  newJXG.on("keyfocusout", function() {
    if (pointerState.dragged.current) {
      callAction({
        action: actions[actionNames.move],
        args: {
          x: calculatedX.current,
          y: calculatedY.current
        }
      });
      pointerState.dragged.current = false;
    }
  });
  newJXG.on("drag", function(e) {
    const viaPointer = e.type === "pointermove";
    const pointerAtDown = pointerState.pointerAtDown.current;
    if (exceededDragThreshold(e, pointerAtDown)) {
      pointerState.dragged.current = true;
    }
    const [xMin, yMax, xMax, yMin] = board.getBoundingBox();
    let width;
    let height;
    let offsetx;
    let offsety;
    let paddingFraction;
    if (params.imageMode) {
      const [imgWidth, imgHeight] = params.imageMode.getCurrentSize();
      const [imgOffsetX, imgOffsetY] = params.imageMode.getCurrentOffset();
      width = imgWidth;
      height = imgHeight;
      offsetx = imgOffsetX;
      offsety = imgOffsetY;
      paddingFraction = params.imageMode.paddingFraction ?? 0.01;
    } else {
      width = params.newJXG.size[0] / board.unitX;
      height = params.newJXG.size[1] / board.unitY;
      const anchorx = params.anchorRel.current?.[0];
      const anchory = params.anchorRel.current?.[1];
      offsetx = 0;
      if (anchorx === "middle") {
        offsetx = -width / 2;
      } else if (anchorx === "right") {
        offsetx = -width;
      }
      offsety = 0;
      if (anchory === "middle") {
        offsety = -height / 2;
      } else if (anchory === "top") {
        offsety = -height;
      }
      paddingFraction = 0.04;
    }
    const xminAdjusted = xMin + paddingFraction * (xMax - xMin) - offsetx - width;
    const xmaxAdjusted = xMax - paddingFraction * (xMax - xMin) - offsetx;
    const yminAdjusted = yMin + paddingFraction * (yMax - yMin) - offsety - height;
    const ymaxAdjusted = yMax - paddingFraction * (yMax - yMin) - offsety;
    const pointAtDownCoords = pointAtDown.current;
    if (viaPointer && pointerAtDown && pointAtDownCoords) {
      const [x, y] = pointerEventToUserCoords(
        e,
        pointerAtDown,
        [
          pointAtDownCoords[0],
          pointAtDownCoords[1],
          pointAtDownCoords[2]
        ],
        board
      );
      calculatedX.current = x;
      calculatedY.current = y;
    } else {
      calculatedX.current = newAnchorPoint.X() + newJXG.relativeCoords.usrCoords[1] - (params.imageMode ? offsetx : 0);
      calculatedY.current = newAnchorPoint.Y() + newJXG.relativeCoords.usrCoords[2] - (params.imageMode ? offsety : 0);
    }
    calculatedX.current = Math.min(
      xmaxAdjusted,
      Math.max(xminAdjusted, calculatedX.current)
    );
    calculatedY.current = Math.min(
      ymaxAdjusted,
      Math.max(yminAdjusted, calculatedY.current)
    );
    callAction({
      action: actions[actionNames.move],
      args: {
        x: calculatedX.current,
        y: calculatedY.current,
        transient: true,
        skippable: true
      }
    });
    newJXG.relativeCoords.setCoordinates(
      jxg.COORDS_BY_USER,
      params.imageMode ? [offsetx, offsety] : [0, 0]
    );
    newAnchorPoint.coords.setCoordinates(
      jxg.COORDS_BY_USER,
      lastPositionFromCore.current
    );
  });
  newJXG.on("keydown", function(e) {
    if (e.key === "Enter") {
      if (pointerState.dragged.current) {
        callAction({
          action: actions[actionNames.move],
          args: {
            x: calculatedX.current,
            y: calculatedY.current
          }
        });
        pointerState.dragged.current = false;
      }
      callAction({
        action: actions[actionNames.clicked],
        args: { componentIdx }
      });
    }
  });
}
function detachAnchoredGraphElement(jxgRef, board) {
  if (!jxgRef.current) {
    return;
  }
  removeJXGEventHandlers(jxgRef.current, LINE_FAMILY_EVENTS);
  board?.removeObject(jxgRef.current);
  jxgRef.current = null;
}
export {
  attachAnchoredGraphDragHandlers as a,
  detachAnchoredGraphElement as d
};
